import React from 'react';
import { RouteAuthenticator as AuthRouteAuthenticator, UnauthenticatedWrapper } from '@blocs.auth';

const RouteAuthenticator = () => (
  <UnauthenticatedWrapper>
    <AuthRouteAuthenticator redirectTo="/default-redirect" />
  </UnauthenticatedWrapper>
);

export default RouteAuthenticator;
